import React from 'react'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { BpSelect } from '../../../../shared/components/forms/select/BpSelect'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import {
  useGetFilterCountryQuery,
  usePostTrademarkRegistrationUpdateMutation,
} from '../../../../app/api'
import { useForm } from 'react-hook-form'
import { renderCountryOption } from '../../../../shared/components/utility/country-option/CountryOption'

interface EditTrademarkRegistrationModalProps {
  data: {
    project_id: number
    trademark_id: number
    registration_id: number
    country_id?: number
    registration_number?: string
  }
}

export const EditTrademarkRegistrationModal = ({ data }: EditTrademarkRegistrationModalProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [updateRegistration, { isLoading }] = usePostTrademarkRegistrationUpdateMutation()
  const { data: countries } = useGetFilterCountryQuery({})

  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })

  const submit = (values: any) => {
    updateRegistration({
      body: {
        project_id: data.project_id,
        trademark_id: data.trademark_id,
        registration_id: data.registration_id,
        ...values,
      },
    }).then(() => {
      dispatch(hideModal())
    })
  }

  return (
    <form className={'flex flex-col'} onSubmit={handleSubmit(submit)}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        Edit registration
      </h3>
      <div className={'flex flex-col gap-[16px] px-[24px] pt-[18px] pb-[16px]'}>
        <BpSelect
          required
          defaultValue={String(data.country_id || '')}
          dropPosition={'auto'}
          label={t('fields.country')}
          optionRender={renderCountryOption}
          options={countries}
          placeholder={t('fields.selectCountry')}
          {...register('country_id', { required: t('fields.validate.required') })}
        />
        <BpInput
          required
          defaultValue={data.registration_number}
          label={t('fields.registrationNumber')}
          placeholder={t('fields.egRegistrationNumber')}
          {...register('registration_number', { required: t('fields.validate.required') })}
        />
      </div>
      <div
        className={
          'flex w-full gap-[12px] border-t-[3px] border-t-[#00326D]/[.02] px-[24px] py-[24px]'
        }
      >
        <BpButton className={'uppercase'} disabled={!isValid || isLoading} type={'submit'}>
          {t('buttons.save')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </form>
  )
}
